<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.controlePedidos.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controlePedidos.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'relatorioVeiculos.controlePedidos.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controlePedidos.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'relatorioVeiculos.controlePedidos.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'relatorioVeiculos.controlePedidos.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'relatorioVeiculos.controlePedidos.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <!-- Carga Inicial da tela -->
    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela == true">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div translate *ngIf="dados?.length <= 0 && cargaTela == false" class="sem-registros text-muted mt-2">
      {{'rmpv.detalhado.nenhumRegistroExibir'}}
    </div>

    <!-- <div translate *ngIf="dados?.length <= 0" class="sem-registros text-muted mt-2">
      {{'rmpv.detalhado.nenhumRegistroExibir'}}
    </div> -->
    <p-table #dt *ngIf="dados?.length > 0" [value]="dados" dataKey="id" selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
      [paginator]="dados?.length > 10" [rows]="10" [loading]="loading" [autoLayout]="false"
      currentPageReportTemplate="{{'relatorioVeiculos.controlePedidos.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
      [globalFilterFields]="['dealer','chassi','marca','modelo','valorVenda','corExterna','corInterna','anoModelo','situacao','status','numeroPedido','numeroNotaFabrica','data']"
      id="excel-table" [scrollable]="true" scrollDirection="both" [style]="{ 'width': '100%' }" scrollHeight="60vh" sortMode="multiple">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width || '150px'" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'relatorioVeiculos.controlePedidos.filtroGeral' | translate}}" />
          </span>
          <p-multiSelect *ngIf="this.translate.currentLang == 'br'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{'relatorioVeiculos.controlePedidos.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'relatorioVeiculos.controlePedidos.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
          <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{'relatorioVeiculos.controlePedidos.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'relatorioVeiculos.controlePedidos.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th [translate]="getTranslate(col.header)" class="text-center" style="background-color:black;color:white;"
              [style.width.px]="col.width" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" class="p-sortable-colum">
              </p-sortIcon>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td class="text-center" [style.width.px]="col.width">
              <ng-container *ngIf="col.field === 'edit'; else normalCell">
         <button 
  pButton 
  type="button" 
  [label]="dados.status || 'Não Atendido'"
  (click)="abrirModal(dados)" 
  style="min-width: 120px"
  [class]="getStatusButtonClass(dados.status)"
  [disabled]="isCadastroPedidoFabricaBloqueado(dados)"
  [style.opacity]="isCadastroPedidoFabricaBloqueado(dados) ? 0.5 : 1"
  [attr.aria-disabled]="isCadastroPedidoFabricaBloqueado(dados)">
</button>
              </ng-container>
              <ng-template #normalCell>
                {{ dados[col.field] }}
              </ng-template>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controlePedidos.filtros.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.controlePedidos.filtros.grupoEconomicoPlaceHolder' | translate }}"
            [options]="gruposEconomicos" optionLabel="descricao" optionValue="id" formControlName="grupo_economico"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controlePedidos.filtros.chassi'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'relatorioVeiculos.controlePedidos.filtros.chassiPlaceHolder' | translate }}"
            formControlName="chassi">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controlePedidos.filtros.numeroPedidoDealer'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'relatorioVeiculos.controlePedidos.filtros.numeroPedidoDealerPlaceHolder' | translate }}"
            formControlName="numeroPedidoDealer">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controlePedidos.filtros.numeroPedidoFabrica'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'relatorioVeiculos.controlePedidos.filtros.numeroPedidoFabricaPlaceHolder' | translate }}"
            formControlName="numeroPedidoFabrica">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controlePedidos.filtros.status'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.controlePedidos.filtros.statusPlaceHolder' | translate }}"
            [options]="statusAtendimentoOptions" optionLabel="label" optionValue="value" formControlName="status"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controlePedidos.filtros.tipoPedido'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.controlePedidos.filtros.tipoPedidoPlaceHolder' | translate }}"
            [options]="tipoPedidoOptions" optionLabel="label" optionValue="value" formControlName="tipoPedido"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'relatorioVeiculos.controlePedidos.filtrar'}}</button>
  </ng-template>
</p-dialog>

<!-- <p-dialog header="{{'relatorioVeiculos.controlePedidos.selecioneDealers' | translate}}"
  [(visible)]="displayFiltrosDealers" [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-dialog [(visible)]="display" header="Cadastrar Pedido Fabrica" [modal]="true">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label translate>{{'relatorioVeiculos.controlePedidos.filtros.numeroPedidoFabrica'}}</label>
        <input type="text" pInputText [(ngModel)]="dadosCadastro.numeroPedido"
          placeholder="{{'relatorioVeiculos.controlePedidos.filtros.numeroPedidoFabricaPlaceHolder' | translate }}" />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label translate>{{'relatorioVeiculos.controlePedidos.filtros.chassi'}}</label>
        <input type="text" pInputText [(ngModel)]="dadosCadastro.chassi" maxlength="17"
          placeholder="{{'relatorioVeiculos.controlePedidos.filtros.chassiPlaceHolder' | translate }}" />
        <small class="p-invalid text-danger" *ngIf="submitted">Precisa conter 17 digitos!</small>
      </div>
    </div>
  </ng-template>
  <p-footer>
    <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="saveDados()"></button>
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </p-footer>
</p-dialog>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>